import { Head, useForm } from '@inertiajs/react';

import { Btn } from '@/Components/Btn';
import { PublicLayout } from '@/Layouts/PublicLayout';

export default function ConfirmPassword() {
    const form = useForm({ password: '' });

    function submit(e: React.FormEvent) {
        e.preventDefault();
        form.post('/user/confirm-password');
    }

    return (
        <PublicLayout>
            <Head title="Confirm password" />
            <div className="max-w-md mx-auto px-6 py-12">
                <h1 className="text-[28px] leading-tight text-ink mb-3">Confirm your password</h1>
                <p className="text-ink-soft text-[14px] mb-6">
                    For security, re-enter your password to continue.
                </p>
                <form onSubmit={submit} className="space-y-4">
                    <input
                        type="password"
                        autoComplete="current-password"
                        required
                        value={form.data.password}
                        onChange={(e) => form.setData('password', e.target.value)}
                        className="w-full p-2 border border-rule rounded bg-card"
                    />
                    {form.errors.password && <p className="text-[12px] text-red-700">{form.errors.password}</p>}
                    <Btn type="submit" full loading={form.processing}>Confirm</Btn>
                </form>
            </div>
        </PublicLayout>
    );
}
